module.exports = __webpack_public_path__ + "img/pen.6abf2531.svg";